<script lang="ts" setup>
interface RichtextProps {
  html?: string
}

defineProps<RichtextProps>()
</script>

<template>
  <div v-html="html" />
</template>
